module.exports = __webpack_public_path__ + "static/media/grid-view.7a083d5e.svg";